import { InferType, string } from "yup";

export const OutcomeSchema = string().oneOf([
  "REVIEW",
  "CLEAR",
  "CRITERIA_NOT_MET",
  "NOT_SET",
]);

// Export shared adjudication outcome type
export type AdjudicationOutcome = InferType<typeof OutcomeSchema>;
